import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class ShowcaseProductCollectionSeoDto
*  SEO-атрибуты страницы подборки.<br>
*/
export class ShowcaseProductCollectionSeoDto extends ActiveModel {

/**
  * metaTitle
  * SEO: заголовок страницы (meta title).<br>Если не задан — витрина генерирует из Domain.Entities.ProductCollections.ProductCollection.Name.<br>
  */
  @ActiveField()
  metaTitle?: null | string


/**
  * metaDescription
  * SEO: описание страницы (meta description).<br>Если не задано — витрина генерирует из Domain.Entities.ProductCollections.ProductCollection.Description.<br>
  */
  @ActiveField()
  metaDescription?: null | string


/**
  * ogImageId
  * SEO: og-картинка. Domain.Entities.Resources.Resource.Id.<br>Если не задана — витрина берёт первое изображение подборки.<br>
  */
  @ActiveField()
  ogImageId?: null | string
}
